import { t } from 'utils/localize';

export default function v_integers_only(value: string, args: { message?: string }) {
  return {
    message: args.message || t('Must only contain whole numbers'),
    validate: () => {
      if (!value) {
        return true;
      }

      const number = Number(value);
      return !isNaN(number) && Number.isInteger(number);
    },
  };
}
